module.exports = __webpack_public_path__ + "img/logo.56693181.png";